import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { usePoll } from 'shared/hooks/usePoll'

import { getAgentLinks } from 'features/auth/actions'

const AgentLinksPolling: React.FC = () => {
  const dispatch = useDispatch()

  const handlePoll = useCallback(async () => {
    dispatch(getAgentLinks())
  }, [dispatch])

  usePoll(handlePoll, { delay: 3 * 60 })

  return null
}

export default AgentLinksPolling
